import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const defaultKeywords =
  "online puja, online puja booking, puja booking, online puja services, best online puja services, puja services online, puja mandir online, online puja mandir, online puja services in india, puja online booking, online puja website, puja booking online, online puja booking services, best online puja, hindu puja online, online pooja booking, online temple pooja booking, online pooja services, book puja online, online puja booking temple, pooja booking online, online temple puja booking, famous temples to visit in india, temples in india, hindu temple, hindu temples near me, temple websites in india, indian mandir, indian temple website, famous temples in india, hindu temples in india, india temples, famous hindu temple, world famous temple in india, india famous hindu temples, famous hindu temple in india,ISO 27001 certified, SOC 2 Type II certified, and PCI DSS Level 1 certified";
const defaultTitle =
  "Book Pandit Ji & Online Puja Services | Temple Dekho";
const defaultDescription =
  "Book verified online puja services across India with TempleDekho. Find trusted pandits, book temples, and perform rituals easily with transparent pricing.";
const HelmetComponent = ({ metaData, jsonLd, children }: any) => {
  useEffect(() => {
    // You could dynamically fetch or update metadata here if needed
    //   title: 'Updated Page Title',
    //   description: 'Updated description after some action.',
    //   imageUrl: 'https://example.com/updated-image.jpg',
    //   url: 'https://example.com/updated-page',
  }, []);

  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;

  let _defaultKeywords = defaultKeywords + (metaData?.keywords ?? "");
  return (
    <div>
      <Helmet>
        {/* SEO Meta Tags */}
        <title>{metaData?.title ?? defaultTitle}</title>
        <meta
          name="description"
          content={metaData?.description ?? defaultDescription}
        />
        <meta name="title" content={metaData?.title ?? defaultTitle} />

        <meta name="keywords" content={`${_defaultKeywords}`} />

        {/* <!-- Canonical URL --> */}
        {/* <link rel="canonical" href={hostname} /> */}

        <meta name="robots" content="index, follow" />

        {/* <!-- Author & Publisher --> */}
        <meta name="author" content="Temple Dekho Team" />
        <meta name="publisher" content="Temple Dekho" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={metaData?.title ?? defaultTitle} />
        <meta
          property="og:description"
          content={metaData?.description ?? defaultDescription}
        />
        <meta property="og:image" content={metaData?.imageUrl} />
        <meta property="og:url" content={metaData?.url} />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaData?.title ?? defaultTitle} />
        <meta
          name="twitter:description"
          content={metaData?.description ?? defaultDescription}
        />
        <meta name="twitter:image" content={metaData?.imageUrl} />
        {jsonLd && (
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        )}
      </Helmet>

      {children}
    </div>
  );
};

export default HelmetComponent;
